import { render } from "./OrdersVe.vue?vue&type=template&id=5e3e3222&scoped=true"
import script from "./OrdersVe.vue?vue&type=script&lang=js"
export * from "./OrdersVe.vue?vue&type=script&lang=js"

import "./OrdersVe.vue?vue&type=style&index=0&id=5e3e3222&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/KAYBU/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3e3222"]])

export default __exports__